export default "__VITE_ASSET__B$BugFLf__"